const AiletAcceptingCollegesHeader = [
    {
      id: 1,
      label: "List of colleges accepting the exam score/rank",
      var: "listofcollegesacceptingtheexamscorerank",
    },
    ];
  export default AiletAcceptingCollegesHeader;
  